import React, {
    useState
}
from "react";

import {
    FontAwesomeIcon
}
from "@fortawesome/react-fontawesome";

import {
    faArrowRight,
    faFolder
}
from "@fortawesome/free-solid-svg-icons";


export default function EvaDirectoryCard({
    item,
    clickFunction
})
{

    //--------------------------------------------------------
    // State
    //--------------------------------------------------------

    const [hovered, setHovered] =
        useState(false);


    //--------------------------------------------------------
    // Image
    //--------------------------------------------------------

    const imageSource =
        item.image
            ?
            `data:${item.imageContentType || "image/jpeg"};base64,${item.image}`
            :
            null;


    //--------------------------------------------------------
    // Render
    //--------------------------------------------------------

    return (

        <div
			className="eva-directory-card"
            style={{
                ...cardStyle,

                transform:
                    hovered
                        ? "translateY(-3px)"
                        : "translateY(0)",

                boxShadow:
                    hovered
                        ? "0 14px 35px rgba(50,35,85,0.12)"
                        : "0 6px 22px rgba(31,25,55,0.06)",

                border:
                    hovered
                        ? "1px solid rgba(112,70,216,0.18)"
                        : "1px solid rgba(65,50,100,0.06)"
            }}

            onMouseEnter={() =>
            {
                setHovered(true);
            }}

            onMouseLeave={() =>
            {
                setHovered(false);
            }}

            onClick={() =>
            {
                if (clickFunction)
                {
                    clickFunction(item);
                }
            }}
        >

            {/* ------------------------------------------------
                Image
            ------------------------------------------------ */}

            <div style={imageContainerStyle} className="eva-directory-card-image">

                {
                    imageSource
                    ?
                    <img
						className="eva-directory-card-image-content"
                        src={imageSource}
                        alt={item.title}
                        style={{
                            ...imageStyle,

                            transform:
                                hovered
                                    ? "scale(1.045)"
                                    : "scale(1)"
                        }}
                    />
                    :
                    <div style={imagePlaceholderStyle}>

                        <FontAwesomeIcon
                            icon={faFolder}
                        />

                    </div>
                }

            </div>


            {/* ------------------------------------------------
                Content
            ------------------------------------------------ */}

            <div style={contentStyle} className="eva-directory-card-content">

                <div style={titleStyle} className="eva-directory-card-title">

                    {item.title || item.name}

                </div>


                {
                    item.description
                    &&
                    <div style={descriptionStyle} className="eva-directory-card-description">

                        {item.description}

                    </div>
                }


                <div
				className="eva-directory-card-arrow"
                    style={{
                        ...arrowStyle,

                        transform:
                            hovered
                                ? "translateX(5px)"
                                : "translateX(0)"
                    }}
                >

                    <FontAwesomeIcon
                        icon={faArrowRight}
                    />

                </div>

            </div>

        </div>

    );

}


//============================================================
// Styles
//============================================================

const cardStyle =
{
    position: "relative",

    width: "100%",
    minHeight: "125px",

    display: "flex",

    background: "#ffffff",

    borderRadius: "14px",

    overflow: "hidden",

    cursor: "pointer",

    boxSizing: "border-box",

    transition:
        "transform 220ms ease, " +
        "box-shadow 220ms ease, " +
        "border 220ms ease"
};


//============================================================
// Image
//============================================================

const imageContainerStyle =
{
    position: "relative",

    width: "185px",
    minWidth: "185px",

    minHeight: "125px",

    overflow: "hidden",

    background:
        "linear-gradient(135deg,#eeeaf8,#f8f7fb)"
};


const imageStyle =
{
    width: "100%",
    height: "100%",

    position: "absolute",

    top: 0,
    left: 0,

    objectFit: "cover",

    display: "block",

    transition:
        "transform 400ms cubic-bezier(0.2, 0.8, 0.2, 1)"
};


const imagePlaceholderStyle =
{
    position: "absolute",

    top: 0,
    left: 0,
    right: 0,
    bottom: 0,

    display: "flex",

    alignItems: "center",
    justifyContent: "center",

    fontSize: "28px",

    color: "#7650d7"
};


//============================================================
// Content
//============================================================

const contentStyle =
{
    position: "relative",

    flex: 1,

    padding: "22px 54px 22px 24px",

    display: "flex",

    flexDirection: "column",

    justifyContent: "center",

    boxSizing: "border-box"
};


const titleStyle =
{
    marginBottom: "7px",

    fontSize: "17px",

    fontWeight: 700,

    color: "#17213b"
};


const descriptionStyle =
{
    maxWidth: "620px",

    fontSize: "13px",

    lineHeight: 1.55,

    color: "#62687b"
};


//============================================================
// Arrow
//============================================================

const arrowStyle =
{
    position: "absolute",

    right: "22px",

    top: "50%",

    marginTop: "-8px",

    color: "#7046d8",

    fontSize: "16px",

    transition:
        "transform 220ms ease"
};